import { render, staticRenderFns } from "./Notinterested.vue?vue&type=template&id=dee23dbe&scoped=true&"
import script from "./Notinterested.vue?vue&type=script&lang=js&"
export * from "./Notinterested.vue?vue&type=script&lang=js&"
import style0 from "./Notinterested.vue?vue&type=style&index=0&id=dee23dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee23dbe",
  null
  
)

export default component.exports